import { create } from '@bufbuild/protobuf'

import type { PhotoRef } from '@jotta/grpc-connect-openapi/photo'
import { PhotoRefSchema } from '@jotta/grpc-connect-openapi/photo'

export function photoRefFromMd5(md5: string): PhotoRef {
  return create(PhotoRefSchema, {
    ref: {
      case: 'md5',
      value: md5,
    },
  })
}
